{
    "warning": "¡ADVERTENCIA!",
    "message": "No ingreses ni pegues código que no entiendes.\nSi usas esta consola, puedes permitir que los atacantes se hagan pasar por ti y roben tu información con un ataque conocido como Self-XSS."
}
